import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BrandM, BrandS } from '@sorare/core/src/atoms/typography';
import { NeonEdge } from '@sorare/core/src/atoms/ui/NeonEdge';
import { Bezel } from '@sorare/core/src/atoms/ui/bezels/Bezel';

import { TutorialBezel } from '../../TutorialBezel';
import { CASH_PRIZE_IN_SOL } from '../../utils';
import solana from '../assets/solana.png';

const StyledNeonEdge = styled(NeonEdge)`
  position: absolute;
  inset: 0;
`;
const Img = styled.img`
  width: calc(5 * var(--unit));
  height: var(--quadruple-unit);
  object-fit: cover;
`;
const StyledBezel = styled(Bezel)`
  padding: var(--double-unit);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  justify-self: center;
`;
const TextWrapper = styled(Horizontal)`
  align-items: baseline;
`;

export const GetRewarded = () => {
  return (
    <TutorialBezel color="#757AEB">
      <Vertical gap={3} center>
        <Vertical center className="text-center">
          <BrandM>
            <FormattedMessage
              id="GetRewarded.title"
              defaultMessage="Get rewarded"
            />
          </BrandM>
          <BodyM color="var(--c-nd-600)">
            <FormattedMessage
              id="GetRewarded.description"
              defaultMessage="Claim your reward right after the game"
            />
          </BodyM>
        </Vertical>
        <StyledBezel background="var(--c-black)" borderColor="#757aeb">
          <Horizontal gap={2}>
            <Img src={solana} alt="" />
            <TextWrapper gap={0.5}>
              <BrandM>{CASH_PRIZE_IN_SOL} SOL</BrandM>
              <BrandS color="var(--c-nd-600)">
                <FormattedMessage
                  id="GetRewarded.reward"
                  defaultMessage="Top Reward"
                />
              </BrandS>
            </TextWrapper>
          </Horizontal>
          <StyledNeonEdge showHalo="never" color="#c9ccfe" />
        </StyledBezel>
      </Vertical>
    </TutorialBezel>
  );
};
